module.exports = __webpack_public_path__ + "static/media/zoho.94fb34d6.png";